export const FILTER_NAME = 'location-unit-report'
